import { supabase } from "../supabaseClient";

const API_BASE = "https://api.reignitespirit.com"; 
//const API_BASE = "http://localhost:8080";
function getSessionId() {
  const key = "rs_session_id";
  let sid = sessionStorage.getItem(key);  // ✅ sessionStorage (per tab)
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem(key, sid);
  }
  return sid;
}

async function waitForAccessToken(retries = 60, delay = 250) {
  for (let i = 0; i < retries; i++) {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) return token;

    if (i === 10) {
      try {
        const { data: refreshData } = await supabase.auth.refreshSession();
        const refreshed = refreshData?.session?.access_token;
        if (refreshed) return refreshed;
      } catch {}
    }

    await new Promise((r) => setTimeout(r, delay));
  }
  return null;
}

export async function apiFetch(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const sessionId = getSessionId();

  const doFetch = async (tokenToUse) => {
    const callerHeaders = options.headers || {};
    const headers = {
      ...callerHeaders,
      "x-session-id": sessionId,
      Authorization: `Bearer ${tokenToUse}`,
    };

    if (!(options.body instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    return fetch(url, {
  ...options,
  mode: "cors",
  cache: "no-store", // ✅ important
  headers: {
    ...headers,
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});
  };

  let token = await waitForAccessToken();
  if (!token) {
    // ✅ last-chance refresh
    const { data: refreshData } = await supabase.auth.refreshSession();
    token = refreshData?.session?.access_token || null;
  }
  if (!token) throw new Error("NO_TOKEN");

  let res = await doFetch(token);

  // refresh once on 401
  if (res.status === 401) {
    const { data: refreshData, error } = await supabase.auth.refreshSession();
    const refreshed = refreshData?.session?.access_token;
    if (!error && refreshed) res = await doFetch(refreshed);
  }

  return res;
}

export async function apiJson(path, options = {}) {
  const res = await apiFetch(path, options);
  const raw = await res.text();

  let data = null;
  try {
    data = raw ? JSON.parse(raw) : null;
  } catch {
    data = raw;
  }

  if (!res.ok) {
    const msg =
      typeof data === "string"
        ? data
        : data?.message || data?.error || `HTTP ${res.status}`;
    throw new Error(msg);
  }

  return data;
}
